import createReducer from '@elab/core/utils/dynaForms/reducers';

import createActions from './actions';
import createSelectors from './selectors';
import createTypes from './types';
import createSagaFactory from './saga';

export const storeName = 'pinCodeForm';
export const getReducers = createReducer;
export const getActions = createActions;
export const getSelectors = createSelectors;
export const getTypes = createTypes;
export const getSagaFactory = createSagaFactory;
